import React from 'react';
import { Global } from '@emotion/react';

const converted = {
    '@media (min-width: 37.5em) and (max-width: 48.0625em)': {
        '.cloud__image--right': { height: '20rem', maxHeight: '20rem' }
    },
    '@media (min-width: 48.0625em) and (max-width: 56.3125em)': {
        '.cloud--full .cloud__content-wrapper': {
            width: '100%',
            backgroundColor: '#009fe4'
        },
        '.cloud__image--right': {
            position: 'relative',
            width: '100%',
            height: '20rem',
            maxHeight: '20rem'
        },
        '.cloud__content-bg img': { marginLeft: '-10rem' },
        label: { whiteSpace: 'nowrap' }
    },
    '@media (min-width: 64em)': {
        '.cloud--full .cloud__content-wrapper': { width: '58%' },
        '.cloud__image--right': { width: '73%' },
        '.input-text,.custom-select>select': { height: '2.5rem' },
        '.form-error': { padding: '0.5rem', fontSize: '0.75rem' },
        label: { whiteSpace: 'nowrap' }
    },
    '@media (min-width: 56.3125em) and (max-width: 64em)': {
        '.cloud--full .cloud__content-wrapper': { width: '81%' },
        '.cloud__image--right': { width: '100%' },
        '.cloud__content-bg img': { marginLeft: '-8rem' }
    },
    '@media (min-width: 64em) and (max-width: 76.5em)': {
        '.cloud--full .cloud__content-wrapper': { width: '73%' },
        '.cloud__image--right': { width: '93%' },
        '.cloud__content-bg img': { marginLeft: '-6rem' }
    },
    '@media (min-width: 76.5em) and (max-width: 81.25em)': {
        '.cloud--full .cloud__content-wrapper': { width: '60%' },
        '.cloud__image--right': { width: '76%' },
        '.cloud__content-bg img': { marginLeft: '-5rem' }
    }
};
export default function BrandedOverrideStyles() {
    return <Global styles={converted} />;
}
